module.exports = __webpack_public_path__ + "img/ts_2017.0a1700a3.jpg";